var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { get, getRawValue } from '../../utils/get';
import { getKeys, hasMissingSchemaVariables } from '../../adapters/utils';
import { updateValueByIdentifier } from '../../tags/values/update-by-identifier';
import { IDENTIFIERS } from '../../types/Identifiers';
import { getCurrentLanguage } from '../blog-post/calculated/getCurrentLanguage';
import { getPageUrl } from './calculated/getPageUrl';
import { buildMultilingualLink } from '../../types/builders';
var IDs = {
    NAME: 'blog-category.name',
    IMAGE: 'blog-category.image',
    IMAGE_HEIGHT: 'blog-category.image.height',
    IMAGE_WIDTH: 'blog-category.image.width',
    PAGE_URL: 'blog-category.url',
    PREV_PAGE_URL: 'blog-category.prevUrl',
    NEXT_PAGE_URL: 'blog-category.nextUrl',
    SD_DISABLE_SCHEMA: 'blog-category.disable-schema',
    SD_JSON_RENDER: 'blog-category.structured-data.render',
};
var userVisible = [IDs.NAME, IDs.PAGE_URL, IDs.IMAGE];
var requiredSchemaVariables = [];
var SchemaTypes = {
    BLOG_CATEGORY_COLLECTION: 'blog-category-collection-preset',
};
export default {
    IDs: IDs,
    SchemaTypes: SchemaTypes,
    requiredSchemaVariables: requiredSchemaVariables,
    getData: function (item) {
        var _a;
        return (_a = {},
            _a[IDs.NAME] = get(item, 'category.label'),
            _a[IDs.IMAGE] = get(item, 'category.image.url'),
            _a[IDs.IMAGE_HEIGHT] = get(item, 'category.image.height'),
            _a[IDs.IMAGE_WIDTH] = get(item, 'category.image.width'),
            _a[IDs.PAGE_URL] = getPageUrl(item),
            _a[IDs.PREV_PAGE_URL] = get(item, 'category.prevUrl'),
            _a[IDs.NEXT_PAGE_URL] = get(item, 'category.nextUrl'),
            _a[IDs.SD_DISABLE_SCHEMA] = hasMissingSchemaVariables(requiredSchemaVariables, item),
            _a[IDs.SD_JSON_RENDER] = get(item, 'category.structuredData'),
            _a);
    },
    getLegacySeoBlob: function (item) {
        var tags = updateValueByIdentifier([], IDENTIFIERS.TITLE, get(item, 'category.title'));
        tags = updateValueByIdentifier(tags, IDENTIFIERS.DESCRIPTION, get(item, 'category.description'));
        return { tags: tags };
    },
    getDynamicPatternsSchema: function (item) {
        var translatedPages = getRawValue(item, 'category.translatedPages') || [];
        var hasTranslations = Boolean(translatedPages.length);
        var currentLanguageCode = getCurrentLanguage(item);
        var currentUrl = getPageUrl(item);
        if (!item || !hasTranslations) {
            return { tags: [] };
        }
        var siteUrl = get(item, 'context.siteUrl');
        var tags = __spreadArrays([
            buildMultilingualLink(currentUrl, currentLanguageCode)
        ], translatedPages.map(function (_a) {
            var langCode = _a.langCode, url = _a.url;
            return buildMultilingualLink(url, langCode);
        }), [
            buildMultilingualLink(siteUrl, 'x-default'),
        ]);
        return { tags: tags };
    },
    getSlug: function () { return ''; },
    updateItemDataWithSlug: function (item) { return item; },
    getBiData: function () { },
    getKeys: function () { return getKeys(IDs, userVisible); },
};
